import { Backdrop, CircularProgress } from '@mui/material';

export function FullScreenLoading() {
    return (
        <Backdrop open>
            <CircularProgress color='inherit' />
        </Backdrop>
    );
}
